import { AxiosResponse } from "axios";

export enum ExportContentType {
  CSV = "text/csv",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}

export const handleFileDownload = async (
  fetchFn: () => Promise<AxiosResponse>
) => {
  try {
    const response = await fetchFn();

    const contentDisposition =
      response.headers["content-disposition"] ?? "";
    let fileName = "";

    const utf8Index = contentDisposition.indexOf("''");
    if (utf8Index !== -1) {
      fileName = decodeURIComponent(
        contentDisposition.substring(utf8Index + 2)
      );
    } else {
      const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
      fileName = match?.[1] ?? "export";
    }

    const file = await response.data.arrayBuffer();
    const url = URL.createObjectURL(new Blob([file]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error occurred, couldn't download file: ", error);
  }
};
